<ng-container *transloco="let t;">
<app-list-view [title]="t('common.labels.templates')" [messages]="messages" [loading]="loading">

  <div buttons>
    <button withRight="admin.template.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
    <button withRight="admin.template.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
  </div>

  <div table>
    <p-table
      [value]="templates"
      [paginator]="true"
      [rows]="20"
      stateStorage="local"
      stateKey="template-list"
      [rowsPerPageOptions]="rowsPerPage"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="t('common.labels.current_page_report')"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width:25%">
          <col style="width:20%">
          <col style="width:20%">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">{{ t('common.labels.name') }}
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="ratingtype_name">{{ t('common.labels.ratingtype') }}
            <p-sortIcon field="ratingtype_name"></p-sortIcon>
          </th>
          <th pSortableColumn="language">{{ t('common.labels.language') }}
            <p-sortIcon field="language"></p-sortIcon>
          </th>
        </tr>
        <tr class="filter">
          <th>
            <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr (click)="onOpen(template)" (keyup.enter)="onOpen(template)" hoverOnRight="admin.template.show" tabindex="0">
          <td><span role="link">{{template.name}} <i *ngIf="template.status === 'inactive'">({{ t('common.deactivated') }})</i></span></td>
          <td>{{ template.ratingtype?.getLang('name', transloco.getActiveLang()) }}</td>
          <td>{{ t(template.getLanguageName()) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="3">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="p-mt-4">
      <app-form-control [cid]="'show_inactive'" [control]="form.get('show_inactive')" [type]="'checkbox'" [label]="t('template_list.show_inactive')"></app-form-control>
    </div>

  </div>

</app-list-view>
</ng-container>
